/**
 * `/production/styles/$styleId/production` — Production tab of the Style
 * File, but addressed by the module that owns the workflow per issue #156
 * rule 4. The Style identity stays in the path; the shell + tab content
 * are the same as `/merchandising/styles/$styleId/...`.
 *
 * @see docs/product/garment-os-screen-build-plan.md §A
 */
import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceShell } from "../../../../features/workspace/index.ts";
import { StyleProductionPage } from "../../../../features/styles/index.ts";

export const Route = createFileRoute("/(workspace)/production/styles/$styleId/production")({
  component: StyleProductionRoute,
});

function StyleProductionRoute() {
  const { styleId } = Route.useParams();
  return (
    <WorkspaceShell
      breadcrumbs={[
        { label: "Production", to: "/" },
        { label: "Style files", to: "/merchandising/styles" },
        { label: "Production" },
      ]}
      contentClassName="max-w-none"
      viewportClassName="p-0 md:p-0"
    >
      <StyleProductionPage styleId={styleId} />
    </WorkspaceShell>
  );
}
